export default __webpack_public_path__ + "static/icon-edit-cells-98ba9760a4c4bd88af35b0609957a1ea.svg";